import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { store } from './store';
import { AppRoutes } from './routes';
import 'react-toastify/dist/ReactToastify.css';
import './styles/global.scss';

// ✅ Add this
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <ScrollToTop /> {/* ✅ Add this */}
                <AppRoutes />
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </BrowserRouter>
        </Provider>
    );
}

export default App;
